import {AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {CommonService} from 'src/app/services/common/common.service';
import {Constant, ContentTypeValues, DefaultNewImages} from 'src/app/common/constant/constant';
import {ViewRoDetailComponent} from '../view-ro-detail/view-ro-detail.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Title} from "@angular/platform-browser";
import * as moment from 'moment';
import {AllDataApiService} from "../../../services/all-data-api/all-data-api.service";
import {RepairOrderService} from 'src/app/services/repair-order.service';
import {RepairOrderService as ROService} from 'src/app/services/repair-order/repair-order.service';
import {HttpClient} from "@angular/common/http";
import {LandingpageService} from "../../../services/landingpage/landingpage.service";
import {BaseService} from "../../../modules/base/base.service";
import {MediaUploadComponent} from "../../media-upload/media-upload.component";
import {MediaManagerService} from "../../../services/media-manager/media-manager.service";
import {AuthenticationService} from "../../../services/authentication/authentication.service";
import {RepairOrderManageComponent} from "../repair-order-manage/repair-order-manage.component";
import {ManageListComponent} from "../manage-list/manage-list.component";
import {ConfirmationComponent} from 'src/app/components/common/confirmation/confirmation.component';
import {NgxQrcodeElementTypes, NgxQrcodeErrorCorrectionLevels} from "@techiediaries/ngx-qrcode";
import {Store} from '@ngrx/store';
import {State} from 'src/app/models/state.model';
import {ImportAction} from 'src/app/actions/import.actions';
import {Subscription} from 'rxjs';

@Component({
    selector: 'app-calpro-adas-report',
    templateUrl: './calpro-adas-report.component.html',
    styleUrls: ['./calpro-adas-report.component.scss']
})
export class CalproAdasReportComponent implements OnInit, AfterViewInit, OnDestroy {
    @Input() roData: any = [];
    @Input() inspectionInfo: any = [];
    @Input() businessInfo: any = [];
    @Input() showAllData: boolean = false;
    @Input() roId: any = 0;
    @Input() roleId: any = 0;
    @Input() pageName: string = '';
    @Input() adasThirdPartData: any = '';
    @Output() calproRefCallback: EventEmitter<any> = new EventEmitter();
    @Output() adasReportEmit: EventEmitter<any> = new EventEmitter();
    @Output() adasThirdPartyDataEmit: EventEmitter<string> = new EventEmitter();

    public logo: string = "";
    public fileAction: string = "view";
    public fileAccess: string = "calpro-adas-upload";
    public hideLabel: boolean = true;
    public copiedModal: boolean = false;
    public innerHeight: any = 600;
    public displayNoRecordsShow = 6;
    public emptyContentType: string = "ADAS Report not available";
    public emptyContentImg: string = DefaultNewImages.ROCalpro;
    public inspectionData: any = [];
    public itemsData: any = [];
    public resultData: any = [];
    public reportData: any = [];
    public surveyData: any = [];
    public attachments: any = [];
    public businessData: any = [];
    public customerInfo: any = [];
    public contactInfo: any = [];
    public emptyList = [];
    public systemInfo: any;
    public referenceAccordion: any;
    public customerDataFlag: boolean = false;
    public contactDataFlag: boolean = false;
    public roFlag: boolean = false;
    public roShopRef: any = '';
    public market: any = '';
    public salesPerson: any = '';
    public additionalSystemId: any = '';
    public additionalSystemInfo: any = [];
    public notes: any = '';
    public roReportMapFlag: boolean = false;
    public maskEmail: string = Constant.maskEmail;
    public reportCreatedByType = 1;
    public additionalReportInfo = [
        {label: 'Workfile ID', value: '-', key: 'workfileId'},
        {label: 'Insurance Company', value: '-', key: 'insuranceCompany'},
    ];

    elementType = NgxQrcodeElementTypes.CANVAS;
    correctionLevel = NgxQrcodeErrorCorrectionLevels.HIGH;
    public damagePositions: any = [{id: 1, damageFlag: false, attachmentCount: 0, attachments: []}, {
        id: 2,
        damageFlag: false,
        attachmentCount: 0,
        attachments: []
    }, {id: 3, damageFlag: false, attachmentCount: 0, attachments: []}, {
        id: 4,
        damageFlag: false,
        attachmentCount: 0,
        attachments: []
    }, {id: 5, damageFlag: false, attachmentCount: 0, attachments: []}, {
        id: 6,
        damageFlag: false,
        attachmentCount: 0,
        attachments: []
    }, {id: 7, damageFlag: false, attachmentCount: 0, attachments: []}, {
        id: 8,
        damageFlag: false,
        attachmentCount: 0,
        attachments: []
    }, {id: 9, damageFlag: false, attachmentCount: 0, attachments: []}, {
        id: 10,
        damageFlag: false,
        attachmentCount: 0,
        attachments: []
    }, {id: 11, damageFlag: false, attachmentCount: 0, attachments: []}, {
        id: 12,
        damageFlag: false,
        attachmentCount: 0,
        attachments: []
    }, {id: 13, damageFlag: false, attachmentCount: 0, attachments: []}, {
        id: 14,
        damageFlag: false,
        attachmentCount: 0,
        attachments: []
    }, {id: 15, damageFlag: false, attachmentCount: 0, attachments: []}];
    public emptyFlag: boolean = false;
    public thirdPartyReport: any = {id: 0, name: '', link: '', jobId: '', data: '', roMapData: {}};
    public removeLoading: boolean = false;
    public loading: boolean = false;
    public updating: boolean = false;
    public address: string = "";
    public phone: string = "";
    public bodyElem;
    public ruleEngines: any = {};
    public adasSystems: any = [];
    public v3AdasSystems: any = [];
    public positionStatements: any = [];
    public enableAllData = false;
    public enableSunCollision = false;
    public allDataDetails: any = {};
    public allDataTokenExpired = false;
    public allDataAuthUrl = null;
    public isNewReport = false;
    public allDataResponseMsg = '';
    public aiResponses = {};


    public loadingPositionStatements = false;
    public loadingAllDataDetails = false;
    public loadingRuleEngineActions = false;
    public loadingAiResponses= {};

    isEditReport: boolean = false;

    public currentLocationId: any;

    public damagedLocations: any = [];
    public errorMessage: string;


    public attachmentsData: any;
    public updatedAttachments: any = [];
    public deletedFileIds: any = [];
    public removeFileIds: any = [];
    public editAttachments: any = [];
    public commentUploadedItemsFlag = false;
    public commentUploadedItemsLength = 0;
    public displayOrder = 0;
    public user;
    public visible: boolean;
    public domainId;
    public userId: any;
    public apiKey: any;
    public countryId: any;
    public reportId: any;
    public postUploadActionTrue = false;
    public postUpload = false;
    public manageAction: string;
    public postApiData: any = {};
    public unsavedChanges = false;

    public mediaConfig: any = {backdrop: 'static', keyboard: false, centered: true, windowClass: 'attachment-modal'};
    public vinNo: string;
    public loadingMediaFile = false;
    public uploadedItemsByLocation: any = {};
    public damagedAttachmentsCount = 0;

    private selectedName: any = [];
    public showCreateRO: boolean = false;
    public v3Report: boolean = false;
    public roSub: Subscription;
    public roMapDataSub: Subscription;

    fixedLocations: Record<number, string[]> = {
        1: ["Bumper - Front", "Grille"],
        2: ["Fender - Front (left)"],
        3: ["Hood"],
        4: ["Fender - Front (right)"],
        5: ["Windshield Area"],
        6: ["Front Door - Driver (left)", "Side Mirror(s)"],
        7: ["Front Door - Passenger (Right)", "Side Mirror(s)"],
        8: ["Roof"],
        9: ["Rear Door - (left)"],
        10: ["Rear Door - (right)"],
        11: ["Quarter Panel - Rear (left)"],
        12: ["Quarter Panel - Rear (right)"],
        13: ["Window - Rear"],
        14: ["Trunk / Decklid / Liftgate/ Tailgate"],
        15: ["Bumper - Rear"]
    };

    constructor(
        private httpClient: HttpClient,
        private commonApi: CommonService,
        private modalService: NgbModal,
        private titleService: Title,
        private allDataApiService: AllDataApiService,
        private baseService: BaseService,
        private authenticationService: AuthenticationService,
        private landingPageService: LandingpageService,
        private mediaApi: MediaManagerService,
        private roApi: RepairOrderService,
        private roService: ROService,
        private store: Store<State>,) {
        this.referenceAccordion = [{
            id: "system",
            class: "system",
            title: "System Information",
            description: "",
            isDisabled: true,
            isExpanded: true
        }];
    }

    ngOnDestroy(): void {
        if (this.roSub) this.roSub.unsubscribe();
        if(this.roMapDataSub) this.roMapDataSub.unsubscribe();
    }

    ngOnInit(): void {
        console.log(this.roData, this.businessInfo, this.inspectionInfo)
        this.emptyFlag = (this.inspectionInfo.length == 0) ? true : false;
        let skipSetup = false;
        if(this.adasThirdPartData == '') {
            this.roService.adasThirdPartyData$.subscribe(data => {
                console.log(data)
                if (data) {
                    this.thirdPartyReport.data = data.reportData;
                    this.thirdPartyReport.roMapData = data.roMapData;
                    this.store.dispatch(
                        new ImportAction({
                            showImporting: false,
                            showIcon: false,
                            text: '',
                            error: false,
                        })
                    );
                    skipSetup = true;
                    this.roService.setAdasThirdPartyData(null);
                    this.adasThirdPartyDataEmit.emit(this.thirdPartyReport);

                    try {
                        let formData = new FormData();
                        formData.append('apiKey', Constant.ApiKey);
                        formData.append('id', this.roId);
                        formData.append('domainId', this.domainId);
                        formData.append('userId', this.userId);

                        this.allDataApiService.generateEstimateByRO(formData).subscribe((response: any) => {
                            console.log(response);
                        });
                    } catch (e) {
                        console.error('Error in generateEstimateByRO:', e);
                    }
                }
            })
        } else {
            this.emptyFlag = false;
            skipSetup = true;
            this.thirdPartyReport = this.adasThirdPartData;
        }

        let logo = localStorage.getItem('blogo');

        this.user = this.authenticationService.userValue;
        this.domainId = this.user.domain_id;
        this.userId = this.user.Userid;
        this.apiKey = Constant.ApiKey;
        this.countryId = localStorage.getItem('countryId');

        if (this.roData?.adasThirdPartyIdInt && this.roData.adasThirdPartyIdInt > 0) {
            this.thirdPartyReport.id = this.roData?.adasThirdPartyIdInt ? this.roData?.adasThirdPartyIdInt : 0;
            this.thirdPartyReport.name = this.roData?.adasThirdPartyFileNameStr ? this.roData?.adasThirdPartyFileNameStr : '';
            this.thirdPartyReport.link = this.roData?.adasThirdPartyLinkStr ? this.roData?.adasThirdPartyLinkStr : '';
            this.thirdPartyReport.jobId = this.roData?.adasThirdPartyJobIdStr ? this.roData?.adasThirdPartyJobIdStr : '';
            this.thirdPartyReport.data = this.roData?.adasThirdPartyDataJsonArr ? this.roData?.adasThirdPartyDataJsonArr : '';
            this.thirdPartyReport.roMapData = {};

            if (!this.thirdPartyReport.data && this.thirdPartyReport.jobId) {
                const apiData = {
                    apiKey: Constant.ApiKey,
                    domainId: this.domainId,
                    userId: this.userId,
                    roId: this.roId,
                    id: this.thirdPartyReport.id
                };

                this.store.dispatch(
                    new ImportAction({
                        showImporting: false,
                        showIcon: false,
                        text: '',
                        error: false,
                    })
                );

                this.store.dispatch(
                    new ImportAction({
                        showImporting: true,
                        showIcon: false,
                        text: 'Processing...',
                        error: false,
                        modalTitle: "3rd Party Report Attachment",
                        downloadIcon: true,
                        generateFile: true,
                        downloadAttachmentFileUrl: "",
                        adasThirdPartyJobId: this.thirdPartyReport.jobId,
                        apiData: apiData,
                    })
                );
            }
        }

        let workOrderStatus = (this.roData.workOrderStatusStr != null || this.roData.workOrderStatusStr != undefined || this.roData.workOrderStatusStr != '') ? parseInt(this.roData.workOrderStatusStr) : 0;
        let checkStatus = [7, 11, 12, 13, 17];
        //let checkStatusFlag = checkStatus.includes(workOrderStatus);
        let checkStatusFlag = false;
        this.roReportMapFlag = (((this.roleId != 4 && this.pageName == 'ro-detail') || (this.pageName == 'nweROscannedVINs')) && this.emptyFlag && !checkStatusFlag) ? true : false;
        if (this.pageName == 'nweROscannedVINs') {
            this.systemInfo = {
                header: false,
                workstreams: [],
                userInfo: []
            };
        }

        if (!this.emptyFlag && !skipSetup) {
            this.setupAdasReport();
        } else {
            setTimeout(() => {
                this.calproRefCallback.emit(this);
            }, 500);
        }

        console.log('ngOnInit called');
        if (!window.location.href.includes('report-wizard')) {
            this.showCreateRO = true;
        }
    }

    setupAdasReport(callack = false) {
        let inspectionData = this.inspectionInfo;
        console.log(this.businessInfo, inspectionData, this.pageName);
        let address1 = (this.businessInfo.addressLine1 != '') ? this.businessInfo.addressLine1 : '';
        let address2 = (this.businessInfo.addressLine2 != '') ? this.businessInfo.addressLine2 : '';
        let city = (this.businessInfo.city != '') ? this.businessInfo.city : '';
        let state = (this.businessInfo.state != '') ? this.businessInfo.state : '';
        let zip = (this.businessInfo.zip != '') ? this.businessInfo.zip : '';
        this.address = address1 + address2 + city + state + zip;
        this.inspectionData = inspectionData[0];
        this.roFlag = (this.inspectionData['roFlag'] && this.inspectionData['roFlag'] != undefined) ? this.inspectionData['roFlag'] : false;
        this.businessData = this.inspectionData['businessInfo'][0];
        this.customerInfo = this.inspectionData['customerInfo'];
        this.reportCreatedByType = this.inspectionData['reportCreatedByType'] || 1; // Default to 1 if not set
        this.customerDataFlag = (Array.isArray(this.customerInfo) && this.customerInfo.length == 0) ? false : true;
        this.customerInfo = (this.customerDataFlag) ? this.customerInfo[0] : [];
        this.contactInfo = this.inspectionData['contactInfo'];
        this.contactDataFlag = (Array.isArray(this.contactInfo) && this.contactInfo.length == 0) ? false : true;
        if ((Array.isArray(this.contactInfo) && this.contactInfo.length > 0)) {
            this.contactInfo = this.contactInfo[0];
        }
        let roShopRef = this.inspectionData['refShopRo'];
        this.roShopRef = (roShopRef == '') ? '-' : roShopRef;
        this.market = (this.inspectionData['marketInfo'].length == 0) ? '-' : this.inspectionData['marketInfo'][0]['name'];
        this.inspectionData.market = this.market;
        this.salesPerson = (this.inspectionData['salesInfo'].length == 0) ? '-' : this.inspectionData['salesInfo'][0]['name'];
        this.inspectionData.salesPerson = this.salesPerson;
        this.additionalSystemId = this.inspectionData['additionalSystemId'];
        this.additionalSystemInfo = this.inspectionData['additionalSystemInfo'];
        this.notes = (this.inspectionData['notes'] == '' || this.inspectionData['notes'] == null) ? '' : this.inspectionData['notes'];
        this.itemsData = this.inspectionData['itemsData'];
        this.resultData = this.itemsData.result;
        this.reportData = this.inspectionData['reportData'];
        this.surveyData = this.inspectionData['surveyData'];
        this.attachments = this.inspectionData['uploadContents'];
        let locationData = this.inspectionData['locationData'];


        try {
            let email = this.customerInfo.email;
            email = (email == null) ? '' : email;
            if (email != '') {
                let splitEmail = email.split(this.maskEmail);
                email = (splitEmail.length > 1) ? '' : email;
                this.customerInfo.email = email;
                this.customerInfo.email = email;
            }

        } catch (e) {
            console.error('Error processing email:', e);
        }


        try {
            let email = this.businessInfo.email;
            email = (email == null) ? '' : email;
            if (email != '') {
                let splitEmail = email.split(this.maskEmail);
                email = (splitEmail.length > 1) ? '' : email;
                this.businessInfo.email = email;
                this.businessInfo.email = email;
            }

        } catch (e) {
            console.error('Error processing email:', e);
        }

        try {
            let email = this.contactInfo.email;
            email = (email == null) ? '' : email;
            if (email != '') {
                let splitEmail = email.split(this.maskEmail);
                email = (splitEmail.length > 1) ? '' : email;
                this.contactInfo.email = email;
                this.contactInfo.email = email;
            }

        } catch (e) {
            console.error('Error processing email:', e);
        }

        //this.logo = (logo && logo != undefined) ? logo : this.itemsData.bannerImage;
        this.logo = this.itemsData.bannerImage;
        let createdOn = this.inspectionData.createdOn;
        createdOn = moment.utc(createdOn).toDate();
        this.inspectionData.createdOnDate = moment(createdOn).local().format('MMM DD, YYYY h:mm A');
        let userInfo = {
            createdBy: this.inspectionData.userName,
            createdOn: this.inspectionData.createdOnDate,
            updatedBy: '-',
            updatedOn: '-'
        };
        this.reportId = this.inspectionData.id;
        this.vinNo = this.inspectionData.vinNo;

        console.log('this.isNewReport', this.isNewReport, this.inspectionData.createdOn, createdOn);
        this.isNewReport = this.inspectionData.createdOn ? moment.utc(this.inspectionData.createdOn).isAfter(moment.utc('2025-01-13')) : false;
        console.log('this.isNewReport', this.isNewReport, createdOn);
        this.systemInfo = {
            header: false,
            workstreams: [],
            userInfo: userInfo
        };

        //check if url contains v=2
        if (window.location.href.includes('v=2') || (this.inspectionData['reportCreatedByType'] == 2) || (this.domainId != '397')) {
            this.v3Report = true;
        }

        locationData.forEach(litem => {
            let attachmentCount = 0;
            let id = parseInt(litem);
            this.damagedLocations.push(id);
            let positionIndex = this.damagePositions.findIndex(option => option.id == id);
            if (positionIndex >= 0) {
                this.attachments.forEach(aitem => {
                    let locationId = parseInt(aitem['locationId']);
                    if (id == locationId) {
                        this.damagePositions[positionIndex]['attachments'].push(aitem);
                        attachmentCount++;
                    }
                });
                this.damagePositions[positionIndex]['attachmentCount'] = attachmentCount;
                this.damagePositions[positionIndex]['damageFlag'] = true;
            }
        });

        console.log('this.resultData ', this.resultData);

        if (this.resultData.features.length > 0) {
            this.resultData.features.forEach(item => {
                item.selected = false;
                if (item.categoryName && item.isVisible != false) {
                    this.adasSystems[item.categoryName] = this.adasSystems[item.categoryName] || [];
                    if (!this.adasSystems[item.categoryName].find((l) => l.subCategoryName === item.subCategoryName)) {
                        this.adasSystems[item.categoryName].push(item);
                    }
                }
            });
            console.log('adasSystems : ', this.adasSystems);
        }
        this.scrollToElem();
        console.log(this.inspectionData, this.damagePositions);
        if (callack) {
            this.loadNewReportDetails();
        }
        setTimeout(() => {
            this.calproRefCallback.emit(this);
        }, 500);
    }

    ngAfterViewInit() {
        console.log('ngAfterViewInit called');
        this.loadNewReportDetails();
    }

    // Scroll to element
    scrollToElem() {
        let element = 'calprosec';
        let secElement = document.getElementById(element);
        if (secElement) {
            secElement.scrollTop;
        }
    }

    // Accordion Open
    onTabOpen(type, item, index) {
        console.log(type, item)
        let checkList;
        switch (type) {
            case 'section':
                break;
        }
    }

// Accordion Close
    onTabClose(type, item, index) {
        let checkList, element;
        switch (type) {
            case 'section':
                element = `section-${index}`;
                break;
        }
    }

    roPOPUP(id) {
        this.bodyElem = document.getElementsByTagName('body')[0];
        if (!document.body.classList.contains("view-modal-popup")) {
            this.bodyElem.classList.add("view-modal-popup");
        }
        if (!document.body.classList.contains("repairorder")) {
            this.bodyElem.classList.add("repairorder");
        }
        const modalRef = this.modalService.open(ViewRoDetailComponent, {
            backdrop: 'static',
            keyboard: true,
            centered: true
        });
        modalRef.componentInstance.repairOrderId = id;
        modalRef.componentInstance.KAServices.subscribe((receivedService) => {
            console.log(receivedService);
            modalRef.dismiss('Cross click');
            /*if(receivedService['action'] == 'delete'){
              setTimeout(() => {
                let threadIndex = this.repairOrderList.findIndex(option => option.id == id);
                this.repairOrderList.splice(threadIndex, 1);
                this.itemTotal -= 1;
                this.itemLength -= 1;
                if(this.repairOrderList.length==0){
                  this.itemOffset = 0;
                  setTimeout(() => {
                    this.getRepairOrderList(false);
                  }, 500);
                }

              }, 1000);
            }*/
            setTimeout(() => {
                this.bodyElem = document.getElementsByTagName('body')[0];
                this.bodyElem.classList.remove("view-modal-popup");
                this.bodyElem.classList.remove("repairorder");
                let title = "scannedVINs";
                this.titleService.setTitle(localStorage.getItem('platformName') + ' - ' + title);
            }, 100);
        });

    }

    beforeParentPanelOpened(panel, appData) {
        panel.isExpanded = true;
        if (panel.id == 'app-info') {
            for (let v of appData) {
                v.isExpanded = true;
            }
        }
        console.log("Panel going to  open!");
    }

    beforeParentPanelClosed(panel, appData) {
        panel.isExpanded = false;
        if (panel.id == 'app-info') {
            for (let v of appData) {
                v.isExpanded = false;
            }
        }
    }

    afterPanelClosed() {
        console.log("Panel closed!");
    }

    afterPanelOpened() {
        console.log("Panel opened!");
    }

    copyLink(value) {
        navigator.clipboard.writeText(value);
        this.copiedModal = true;
        setTimeout(() => {
            this.copiedModal = false;
        }, 1200);
    }

    objectKeys(obj: any): string[] {
        try {
            if (obj === null || obj === undefined) {
                return [];
            }
            return Object.keys(obj);
        } catch (e) {
            console.error('Error in objectKeys:', e);
            return [];
        }
    }

    chunkArray(array: any[], chunkSize: number): any[][] {
        const chunks = [];
        for (let i = 0; i < array.length; i += chunkSize) {
            chunks.push(array.slice(i, i + chunkSize));
        }
        return chunks;
    }

    loadNewReportDetails(reportId = '', vinNo = '') {
        try {
            if (this.isNewReport && !this.loadingAllDataDetails && !this.loadingPositionStatements && !this.loadingRuleEngineActions) {
              console.log('in load data')
              this.enableAllData = localStorage.getItem('enable_all_data') === '1';
              this.enableSunCollision = localStorage.getItem('enable_sun_collision') === '1';
              this.loadPositionStatements();
              this.loadRuleEngineActions(reportId, vinNo);
              this.loadAllDataDetails(reportId, vinNo);
            } else {
              this.loadingAllDataDetails = false;
              this.loadingPositionStatements = false;
              this.loadingRuleEngineActions = false;
            }
        } catch (e) {
            console.error('Error in loadNewReportDetails:', e);
            this.loadingAllDataDetails = false;
            this.loadingPositionStatements = false;
            this.loadingRuleEngineActions = false;
        }
    }

    loadAllDataDetails(reportId: any = '', vinNo = '') {
        if ((!this.enableAllData && !this.loadingAllDataDetails) || this.allDataDetails.length > 0) {
            return;
        }
        if (!this.loading && !this.loadingAllDataDetails) {
            reportId = (reportId == '') ? this.inspectionData.id : reportId;
            this.loadingAllDataDetails = true;
            this.allDataApiService.filterDataByReportId(reportId, this.v3Report, this.showAllData).subscribe((response) => {
                    console.log('filterDataByReportId response', response);
                    this.loadingAllDataDetails = false;
                    this.allDataDetails = response.data;
                    this.additionalReportInfo = response?.additionalInfo || this.additionalReportInfo;
                    if (response.code === 401) {
                        this.allDataTokenExpired = true;
                        this.allDataAuthUrl = response.authUrl;
                        this.allDataResponseMsg = response.message;
                    }
                    this.allDataResponseMsg = response.message;

                    this.v3AdasSystems = response?.adasSystems || this.v3AdasSystems;
                    console.log('adasSystems : ', this.v3AdasSystems);
                    this.loadAIResponses();
                },
                (error) => {
                    console.error('Error in filterDataByReportId:', error);
                    this.loadingAllDataDetails = false;
                });
        }
    }

    loadPositionStatements() {
        if (this.loadingPositionStatements || this.positionStatements?.length > 0) {
            return;
        }
        this.loadingPositionStatements = true;
        this.allDataApiService.getPositionStatements(this.resultData.make).subscribe((response) => {
                console.log('loadPositionStatements response', response);
                this.positionStatements = response;
                this.loadingPositionStatements = false;
            },
            (error) => {
                console.error('Error in loadPositionStatements:', error);
                this.loadingPositionStatements = false;
            });
    }

    loadRuleEngineActions(reportId = '', vinNo = '') {
        if (this.loadingRuleEngineActions || this.ruleEngines?.length > 0 || !this.resultData.make || !this.resultData.make.trim()) {
            return;
        }
        let vin = (vinNo == '') ? this.inspectionData.vinNo : vinNo;
        reportId = (reportId == '') ? this.inspectionData.id : reportId;
        this.loadingRuleEngineActions = true;
        try {
            const apiFormData = {
                reportId,
                vin,
                userId: localStorage.getItem('userId'),
                manufacturer: this.resultData.make,
                isNewVersion: this.v3Report
            };
            this.allDataApiService.getRuleEngineActions(apiFormData).subscribe((ruleEnginesResponse: any) => {
                    this.ruleEngines = ruleEnginesResponse.data;
                    this.loadingRuleEngineActions = false;
                },
                (error) => {
                    console.error('Error in loadRuleEngineActions:', error);
                    this.loadingPositionStatements = false;
                });
        } catch (e) {
            console.error('Error in loadRuleEngineActions:', e);
            this.loadingPositionStatements = false;
        }
    }

    syncAllDataAccessToken() {
        const stateUrl = new URL(window.location.href).origin + new URL(window.location.href).pathname;
        window.location.href = `${Constant.collabticV3ApiUrl}/all-data/authorize?userId=${localStorage.getItem('userId')}&state=${stateUrl}`;
    }

    openSunCollisionLink() {
        this.loading = true;
        this.httpClient.get(`${Constant.collabticV3ApiUrl}/sun-collision/get-transfer-ticket`).subscribe((response) => {
            console.log('openSunCollisionLink response', response);
            const sunCollisionURL = `https://sandbox.sun.collisiontechdata.com/v1/direct?transferTicket=${response['transfer_ticket']}&vin=${this.inspectionData.vinNo}`;
            console.log('openSunCollisionLink urls', sunCollisionURL);
            setTimeout(() => {
                this.loading = false;
                window.open(sunCollisionURL);
                // window.location.href = sunCollisionURL;
            }, 2000);
        });
    }

    onSurveyChange(survey: any, statusStr: number) {
        survey.status = statusStr;
    }

    saveSurvey() {
        this.updating = true;
        const domainIdStr = localStorage.getItem('domainId');
        const userIdStr = localStorage.getItem('userId');
        const formData = new FormData();

        formData.append('notes', '');
        formData.append('apiKey', Constant.ApiKey);
        formData.append('reportId', `${this.inspectionData.id}`);
        formData.append('contactId', '');
        formData.append('userId', userIdStr);
        formData.append('domainId', domainIdStr);
        formData.append('countryId', '1');
        formData.append('platform', '3');
        formData.append('marketId', '');
        formData.append('additionalType', '1');
        formData.append('shopId', '');
        formData.append('salesRepId', '');

        const itemsObj: { [key: string]: string } = {};
        this.surveyData.forEach(item => {
            itemsObj[item.id] = item.status;
        });

        formData.append('items', JSON.stringify([itemsObj]));

        this.landingPageService.updateInspectionSurvey(formData).subscribe((response) => {
            console.log(response);
            this.callSolrAPI();
        }, (error) => {
            console.log(error);
        });
    }

    public callSolrAPI() {
        const userIdStr = localStorage.getItem('userId');
        const domainIdStr = localStorage.getItem('domainId');
        const apiDatasocial = new FormData();
        apiDatasocial.append('apiKey', Constant.ApiKey);
        apiDatasocial.append('domainId', domainIdStr);
        apiDatasocial.append('threadId', this.inspectionData.id);
        apiDatasocial.append('userId', userIdStr);
        apiDatasocial.append('action', 'update');
        apiDatasocial.append('actionType', '16');
        apiDatasocial.append('platform', '3');
        this.baseService.postFormData('forum', 'UpdateDatetoSolr', apiDatasocial).subscribe((response: any) => {
            console.log('UpdateDatetoSolr response', response);
            this.updating = false;
        });
    }


    markAsDamaged(position) {
        const positionId = position.id;
        position.damageFlag = !position.damageFlag;

        if (this.damagedLocations.includes(positionId)) {
            this.damagedLocations = this.damagedLocations.filter(item => item !== positionId);
        } else {
            this.damagedLocations.push(positionId);
        }
        this.errorMessage = '';

    }

    attachmentPopup(position) {
        console.log('position', position);
        this.currentLocationId = position.id;
        this.showMediaUploadModal(position.id);
    }

    private showMediaUploadModal(positionId) {
        let fitem = [];
        const mitem = [];
        const obj = {};
        this.manageAction = 'uploading';
        this.postApiData = {
            action: 'new-damaged-vehicle',
            access: 'damaged-vehicle',
            pageAccess: 'damaged-vehicle',
            apiKey: Constant.ApiKey,
            domainId: this.domainId,
            countryId: '',
            userId: this.userId,
            threadId: '',
            postId: '',
            locationId: positionId,
            // tslint:disable-next-line:radix
            contentType: parseInt(ContentTypeValues.DamagedVehicle),
            displayOrder: this.displayOrder,
            roPushApiFlag: false,
            shopId: 0,
            assignTech: [],
            uploadedItems: [],
            attachments: [],
            attachmentItems: [],
            updatedAttachments: [],
            deletedFileIds: [],
            removeFileIds: [],
            pushData: obj
        };

        if (this.uploadedItemsByLocation[positionId]?.uploadedItems) {
            if (this.uploadedItemsByLocation[positionId]?.uploadedItems?.items?.length > 0) {
                fitem = this.uploadedItemsByLocation[positionId]?.uploadedItems;
                this.postApiData['uploadedItems'] = this.uploadedItemsByLocation[positionId]?.uploadedItems?.items;
                this.postApiData['attachments'] = this.uploadedItemsByLocation[positionId]?.uploadedItems?.attachments;
            }
        }

        if (!this.uploadedItemsByLocation[positionId]) {
            this.uploadedItemsByLocation[positionId] = {
                uploadedItems: {}
            };
        }

        const modalRef = this.modalService.open(MediaUploadComponent, this.mediaConfig);
        modalRef.componentInstance.access = 'post';
        modalRef.componentInstance.fileAttachmentEnable = true;
        modalRef.componentInstance.mediaAttachments = true;
        modalRef.componentInstance.apiData = this.postApiData;
        modalRef.componentInstance.uploadedItems = fitem;
        modalRef.componentInstance.presetAttchmentItems = mitem;
        this.loadingMediaFile = true;
        modalRef.componentInstance.uploadAttachmentAction.subscribe((receivedService) => {
            console.log('attachments receivedService : ', receivedService);
            console.log('attachments receivedService : ', this.reportId, this.userId, this.domainId);
            // tslint:disable-next-line:triple-equals
            if (receivedService && receivedService.uploadedItems && this.reportId != '' && this.userId != '' && this.domainId != '') {
                this.uploadedItemsByLocation[positionId].uploadedItems = receivedService.uploadedItems;
                this.attachmentsData = receivedService.editAttachments;
                this.deletedFileIds = receivedService.deletedFileIds;
                this.removeFileIds = receivedService.removeFileIds;
                this.updatedAttachments = receivedService.updatedAttachments;


                this.postApiData.dataId = this.reportId;
                this.postApiData.locationId = positionId;
                this.postApiData.access = 'damaged-vehicle';
                this.postApiData.pageAccess = 'damaged-vehicle';

                if (this.deletedFileIds.length > 0) {
                    this.deletedFileIds.forEach((mediaId) => {
                        let apiData = {
                            apiKey: Constant.ApiKey,
                            domainId: this.domainId,
                            countryId: '1',
                            userId: this.userId,
                            mediaId: mediaId
                        }

                        this.mediaApi.deleteMedia(apiData).subscribe((response) => {
                            console.log('deleteMedia', response);
                        });
                    });
                }

                this.loadingMediaFile = false;
                console.log('attachments uploadedItemsByLocation : ', this.uploadedItemsByLocation[positionId].uploadedItems);
                // tslint:disable-next-line:triple-equals
                if ((this.uploadedItemsByLocation[positionId]?.uploadedItems?.items) && (this.uploadedItemsByLocation[positionId]?.uploadedItems?.attachments)) {
                    this.postApiData.uploadedItems = this.uploadedItemsByLocation[positionId].uploadedItems.items;
                    this.postApiData.attachments = this.uploadedItemsByLocation[positionId].uploadedItems.attachments;

                    console.log('attachments uploadedItems : ', this.uploadedItemsByLocation[positionId].uploadedItems);

                    if (this.uploadedItemsByLocation[positionId].uploadedItems.items) {
                        // update damagePositions
                        const damagePosition = this.damagePositions.find(item => item.id === positionId);
                        const positionIndex = this.damagePositions.findIndex(option => option.id == positionId);
                        if (damagePosition) {
                            damagePosition.attachmentCount = this.uploadedItemsByLocation[positionId].uploadedItems.attachments.length;
                            damagePosition.attachments = this.uploadedItemsByLocation[positionId].uploadedItems.attachments;
                            this.damagePositions[positionIndex].attachments = damagePosition.attachments;
                            this.damagePositions[positionIndex].attachmentCount = damagePosition.attachmentCount;
                            console.log('attachments 1 : ', this.uploadedItemsByLocation[positionId].uploadedItems.items);
                            console.log('attachments 2 : ', damagePosition.attachments);
                        }

                        if (damagePosition.attachmentCount > 0) {
                            this.damagedAttachmentsCount += damagePosition?.attachmentCount ? damagePosition?.attachmentCount : 0;
                            //    do nothing
                        } else {
                            this.damagedAttachmentsCount -= this.deletedFileIds?.length ? this.deletedFileIds.length : 0;
                            const positionIndex = this.damagePositions.findIndex(option => option.id == positionId);
                            this.damagePositions[positionIndex].attachments = [];
                            this.damagePositions[positionIndex].attachmentCount = 0;
                            this.damagePositions[positionIndex].damageFlag = true;
                            this.damagedAttachmentsCount = 0;
                        }

                        this.commentUploadedItemsLength = this.uploadedItemsByLocation[positionId].uploadedItems.items.length;
                        this.commentUploadedItemsFlag = true;
                    } else {
                        this.commentUploadedItemsLength = 0;
                        this.commentUploadedItemsFlag = false;
                    }
                } else {
                    this.commentUploadedItemsLength = 0;
                    this.commentUploadedItemsFlag = false;
                }
                // tslint:disable-next-line:triple-equals
                if (this.attachmentsData != '') {
                    if (this.attachmentsData && this.attachmentsData.length > 0) {
                        this.commentUploadedItemsLength = this.commentUploadedItemsLength + this.attachmentsData.length;
                        this.commentUploadedItemsFlag = true;
                    }
                }
            }

            modalRef.dismiss('Cross click');
        });
    }

    uploadComplete(apiData) {
        console.log('attachments uploadComplete ', apiData);

        setTimeout(() => {
            this.loadingMediaFile = false;
            this.postUploadActionTrue = false;
            this.postUpload = false;
        }, 100);
    }

  public getAIResponses(allDataInfo: any = {}, isSearch = false) {
      if (!this.loading && !this.loadingAiResponses[allDataInfo.id]) {
        this.loadingAiResponses[allDataInfo.id] = true;
        console.log('getAIResponses called for ', allDataInfo.id);
        this.allDataApiService.getAIResponses(this.reportId, isSearch, allDataInfo).subscribe((response) => {
            console.log('getAIResponses response', response.data);
            this.loadingAiResponses[allDataInfo.id] = false;
            this.aiResponses[allDataInfo.id] = response.data;
            console.log('aiResponses : ', this.aiResponses);
          },
          (error) => {
            console.error('Error in getAIResponses:', error);
            this.loadingAiResponses[allDataInfo.id] = false;
          });
      }
    }


    public saveAllDamagedLocations() {
        this.updating = true;
        this.saveDamagedLocations().then(() => {
            return new Promise((resolve, reject) => {
                this.isEditReport = false;
                this.updating = false;
                resolve(true);
            });
        });
    }

    private saveDamagedLocations(): Promise<any> {
        return new Promise((resolve, reject) => {
            if (this.unsavedChanges && this.damagedLocations.length > 0) {
                this.loadingMediaFile = true;
                this.postUploadActionTrue = true;
                this.postUpload = true;
                this.unsavedChanges = false;
            }
            if ((this.damagedLocations.length > 0)) {
                this.loadingMediaFile = true;
                this.postUploadActionTrue = true;
                this.postUpload = true;
                const formData = new FormData();
                formData.append('apiKey', Constant.ApiKey);
                formData.append('domainId', this.domainId);
                formData.append('userId', this.userId);
                formData.append('reportId', this.reportId);
                formData.append('vin', this.vinNo);
                formData.append('countryId', '1');
                formData.append('platform', '3');
                formData.append('locationData', JSON.stringify(this.damagedLocations));

                console.log('save', formData);
                this.landingPageService.findAdasVehicleLocations(formData).subscribe((response) => {
                    console.log('findAdasVehicleLocations', response);
                    this.callSolrAPI();
                    resolve(response);
                });
            } else {
                // this.errorAlert('Please select at least one location to mark as damaged');
                // resolve(true);
                this.errorMessage = 'Please select at least one location to mark as damaged';
            }
        });
    }


    openRepairOrderPOPUP(type, id) {
        console.log('openRepairOrderPOPUP ', type, id);
        this.bodyElem = document.getElementsByTagName('body')[0];
        if (!document.body.classList.contains('view-modal-popup')) {
            document.body.classList.add('view-modal-popup');
        }
        if (!document.body.classList.contains('view-modal-popup-manage')) {
            document.body.classList.add('view-modal-popup-manage');
        }
        if (!document.body.classList.contains('landing-page')) {
            document.body.classList.add('landing-page');
        }

        console.log(this.inspectionData)
        let calproAdasReportData = [];
        calproAdasReportData.push(this.inspectionData);
        const modalRef = this.modalService.open(RepairOrderManageComponent, {backdrop: 'static', keyboard: false, centered: true, size: 'max-width-ro'});
        modalRef.componentInstance.workOrderPage = 'view-page';
        modalRef.componentInstance.workOrderType = type;
        modalRef.componentInstance.workOrderId = id;
        modalRef.componentInstance.calproAdasReportData = calproAdasReportData;
        modalRef.componentInstance.createParamSalesRepId = `${this.inspectionData.salesInfo?.length > 0 ? this.inspectionData.salesInfo[0].id : ''}`;
        modalRef.componentInstance.createParamShopId = `${this.inspectionData.customerInfo?.length > 0 ? this.inspectionData.customerInfo[0].id : ''}`;
        modalRef.componentInstance.createParamMarketId = `${this.inspectionData.marketInfo?.length > 0 ? this.inspectionData.marketInfo[0].id : ''}`;
        modalRef.componentInstance.createParamContactId = `${this.inspectionData.contactInfo?.length > 0 ? this.inspectionData.contactInfo[0].id : ''}`;
        modalRef.componentInstance.createParamReportId = `${this.inspectionData.id}`;
        modalRef.componentInstance.createParamVIN = `${this.inspectionData.vinNo}`;

        modalRef.componentInstance.ROManageService.subscribe((receivedService) => {
            const action = receivedService.action;

            if (action == 'update') {
                document.body.classList.remove('landing-page');
                document.body.classList.remove('view-modal-popup');
                document.body.classList.remove('view-modal-popup-manage');
                this.updating = true;
                window.location.reload();
                try {
                    if (modalRef != undefined) {
                        document.body.classList.remove('view-modal-popup');
                        document.body.classList.remove('view-modal-popup-manage');
                        modalRef.dismiss('Cross click');
                    }
                } catch (e) {
                }
            }

            if (action == 'close') {
                document.body.classList.remove('landing-page');
                document.body.classList.remove('view-modal-popup');
                document.body.classList.remove('view-modal-popup-manage');
                try {
                    if (modalRef != undefined) {
                        modalRef.dismiss('Cross click');
                    }
                } catch (e) {
                }
            }
        });
    }

    addAdditional() {
        this.manageShopList();
    }

    manageShopList() {
        this.domainId = localStorage.getItem('domainId');
        this.userId = localStorage.getItem('userId');
        const apiData = {
            apiKey: Constant.ApiKey,
            domainId: this.domainId,
            userId: this.userId,
            type: '',
            view: 1,
            id: '',
            isActive: '',
            name: '',
            limit: 20,
            offset: 0,
            platform: 1,
            searchKey: ''
        };

        let access;
        let filteredItems;
        let filteredNames;
        let inputData = {};

        access = 'additionalSystems';

        //update selectedid and selectedname from additionalSystemInfo
        if (this.additionalSystemInfo?.length) {
            this.additionalSystemId = [];
            this.selectedName = [];
            this.additionalSystemInfo.forEach((item) => {
                this.additionalSystemId.push(item.id);
                this.selectedName.push(item.name);
            });
        }

        filteredItems = [...this.additionalSystemId];
        filteredNames = [...this.selectedName];
        inputData = {
            actionApiName: 'adas-vehicle/manage-additional-system',
            actionQueryValues: '',
            selectionType: 'multiple',
            field: 'additional',
            title: 'Additional',
            filteredItems,
            filteredLists: filteredNames,
            countryId: 1,
            baseApiUrl: Constant.collabticV3ApiUrl,
            apiUrl: Constant.collabticV3ApiUrl + Constant.manageAdditionalSystemsApiUrl,
            apiData,
        };

        const modalRef = this.modalService.open(ManageListComponent, {backdrop: 'static', keyboard: true, centered: true});
        modalRef.componentInstance.access = access;
        modalRef.componentInstance.inputData = inputData;
        modalRef.componentInstance.accessAction = true;
        modalRef.componentInstance.filteredItems = filteredItems;
        modalRef.componentInstance.filteredLists = filteredNames;
        modalRef.componentInstance.filteredTags = filteredItems;
        modalRef.componentInstance.apiData = apiData;
        modalRef.componentInstance.height = innerHeight - 140;
        modalRef.componentInstance.selectedItems.subscribe((receivedService) => {
            console.log(receivedService);
            this.additionalSystemInfo = receivedService;
            const items = receivedService;
            this.additionalSystemId = [];
            this.selectedName = [];
            // tslint:disable-next-line:forin
            for (const t in items) {
                const chkIndex = this.additionalSystemId.findIndex(
                    // tslint:disable-next-line:triple-equals
                    (option) => option == items[t].id
                );
                if (chkIndex < 0) {
                    this.additionalSystemId.push(items[t].id);
                    this.selectedName.push(items[t].name);
                }
            }
            this.bodyElem = document.getElementsByTagName('body')[0];
            this.bodyElem.classList.remove('certification-modal');
            this.bodyElem.classList.remove('profile-certificate');
            modalRef.dismiss('Cross click');
        });
        modalRef.componentInstance.thirdPartyReport.subscribe((receivedService) => {
            this.thirdPartyReport.id = receivedService.id;
            this.thirdPartyReport.name = receivedService.fileName;
            this.thirdPartyReport.link = receivedService.reportLink;
            this.thirdPartyReport.jobId = receivedService.jobId;

            const apiData = {
                apiKey: Constant.ApiKey,
                domainId: this.domainId,
                userId: this.userId,
                roId: this.roId,
                id: receivedService.id
            };

            this.store.dispatch(
                new ImportAction({
                    showImporting: true,
                    showIcon: false,
                    text: 'Processing...',
                    error: false,
                    modalTitle: "3rd Party Report Attachment",
                    downloadIcon: true,
                    generateFile: true,
                    downloadAttachmentFileUrl: "",
                    adasThirdPartyJobId: receivedService.jobId,
                    apiData: apiData,
                })
            );
        });
    }

    saveAdasEdit() {
        if (this.additionalSystemId.length == 0) {
            return;
        }
        this.updating = true;
        const domainIdStr = localStorage.getItem('domainId');
        const userIdStr = localStorage.getItem('userId');

        const createParamSalesRepId = `${this.inspectionData.salesInfo?.length > 0 ? this.inspectionData.salesInfo[0].id : ''}`;
        const createParamShopId = `${this.inspectionData.customerInfo?.length > 0 ? this.inspectionData.customerInfo[0].id : ''}`;
        const createParamMarketId = `${this.inspectionData.marketInfo?.length > 0 ? this.inspectionData.marketInfo[0].id : ''}`;
        const createParamContactId = `${this.inspectionData.contactInfo?.length > 0 ? this.inspectionData.contactInfo[0].id : ''}`;

        const formData = new FormData();

        formData.append('notes', this.notes);
        formData.append('apiKey', Constant.ApiKey);
        formData.append('reportId', `${this.reportId}`);
        formData.append('userId', userIdStr);
        formData.append('domainId', domainIdStr);
        formData.append('countryId', '1');
        formData.append('platform', '3');
        formData.append('additionalType', '1');
        formData.append('additionalSystem', JSON.stringify(this.additionalSystemId));
        formData.append('marketId', createParamMarketId);
        formData.append('shopId', createParamShopId);
        formData.append('contactId', createParamContactId);
        formData.append('salesRepId', createParamSalesRepId);

        const itemsObj: { [key: string]: string } = {};
        this.surveyData.forEach(item => {
            itemsObj[item.id] = item.status;
        });

        formData.append('items', JSON.stringify([itemsObj]));

        this.landingPageService.updateInspectionSurvey(formData).subscribe((response) => {
            console.log(response);
            this.updating = false;
        }, (error) => {
            console.log(error);
        });
    }

    removeAdditional(item: any) {
        const index = this.additionalSystemInfo.indexOf(item);
        if (index >= 0) {
            this.additionalSystemInfo.splice(index, 1);
            this.additionalSystemId.splice(index, 1);
        }
    }

    saveReport() {
        this.isEditReport = false;
        this.saveAllDamagedLocations();
        this.saveAdasEdit();
        this.saveSurvey();
        this.updateAdasReport();
    }

    private updateAdasReport() {
        const apiFormData = {
            apikey: Constant.ApiKey,
            reportId: this.inspectionData.id,
            userId: localStorage.getItem('userId'),
            all_data_info: this.allDataDetails,
        };
        this.allDataApiService.updateAllDataLinks(apiFormData).subscribe((response) => {
            console.log('updateAllDataLinks response', response);
        });
    }

    removeAllDataLink(link: any) {
        this.allDataDetails = this.allDataDetails.filter((item) => item !== link);
    }

    adasReportActionCallaback() {
        this.domainId = localStorage.getItem('domainId');
        this.userId = localStorage.getItem('userId');
        const apiData = {
            apiKey: Constant.ApiKey,
            domainId: this.domainId,
            userId: this.userId,
            type: '',
            view: 1,
            id: '',
            isActive: '',
            name: '',
            limit: 20,
            offset: 0,
            platform: 1,
            searchKey: ''
        };

        let access;
        let filteredItems = [];
        let filteredNames = [];
        let inputData = {};

        access = 'adasCalproReport';

        inputData = {
            actionApiName: Constant.getOpenCalproReportApiUrl,
            actionQueryValues: '',
            selectionType: 'single',
            field: 'adasCalproReport',
            title: 'Attach ADAS Report',
            filteredItems,
            filteredLists: filteredNames,
            countryId: 1,
            baseApiUrl: Constant.collabticV3ApiUrl,
            apiUrl: Constant.collabticV3ApiUrl + Constant.getOpenCalproReportApiUrl,
            apiData,
        };

        let apiDataAttachments = {
            apiKey: this.apiKey,
            domainId: this.domainId,
            countryId: this.countryId,
            userId: this.userId,
            uploadedItems: [],
            attachments: this.attachments,
            access: access,
            displayOrder: this.displayOrder,
            solrType: '',
            trainingMode: '',
            dataId: this.roId,
            contentType: 50,
        };
        const modalRef = this.modalService.open(ManageListComponent, {backdrop: 'static', keyboard: true, centered: true});
        modalRef.componentInstance.access = access;
        modalRef.componentInstance.inputData = inputData;
        modalRef.componentInstance.accessAction = false;
        modalRef.componentInstance.filteredItems = filteredItems;
        modalRef.componentInstance.filteredLists = filteredNames;
        modalRef.componentInstance.filteredTags = filteredItems;
        modalRef.componentInstance.apiData = apiData;
        modalRef.componentInstance.apiDataCalproAttachments = apiDataAttachments;
        modalRef.componentInstance.height = innerHeight - 140;
        modalRef.componentInstance.selectedItems.subscribe((receivedService) => {
            console.log(receivedService);
            let responseItem = receivedService;
            this.bodyElem = document.getElementsByTagName('body')[0];
            this.bodyElem.classList.remove('certification-modal');
            this.bodyElem.classList.remove('profile-certificate');
            modalRef.dismiss('Cross click');
            if (responseItem) {
                let action = 'map';
                let adasReportId = parseInt(responseItem[0].id);
                let vinNo = this.roData.vinNo;
                let selectedVin = responseItem[0].name;
                let actionReportFlag = (vinNo != selectedVin) ? false : true;
                if (this.roId == 0 && this.pageName == 'nweROscannedVINs') {
                    actionReportFlag = true;
                }
                if (actionReportFlag) {
                    if (this.roId > 0) {
                        this.calproReportAction(action, adasReportId, responseItem[0]);
                    } else {
                        this.reportId = adasReportId;
                        this.getReportData(adasReportId, selectedVin);
                    }
                } else {
                    const modalConfRef = this.modalService.open(ConfirmationComponent, {backdrop: 'static', keyboard: true, centered: true});
                    modalConfRef.componentInstance.access = 'alert';
                    modalConfRef.componentInstance.bodyTxtAlert = `ADAS Report and RO VIN number is not the same. Are you sure you want to attach the report?`;
                    modalConfRef.componentInstance.confirmAction.subscribe((receivedResponse) => {
                        modalConfRef.dismiss('Cross click');
                        console.log(receivedResponse);
                        if (receivedResponse) {
                            if (this.roId > 0) {
                                this.calproReportAction(action, adasReportId, responseItem[0]);
                            } else {
                                this.reportId = adasReportId;
                                this.getReportData(adasReportId, selectedVin);
                            }
                        }
                    });
                }
            }
        });
        modalRef.componentInstance.thirdPartyReport.subscribe((receivedService) => {
            this.thirdPartyReport.id = receivedService.id;
            this.thirdPartyReport.name = receivedService.fileName;
            this.thirdPartyReport.link = receivedService.reportLink;
            this.thirdPartyReport.jobId = receivedService.jobId;

            const apiData = {
                apiKey: Constant.ApiKey,
                domainId: this.domainId,
                userId: this.userId,
                roId: this.roId,
                id: receivedService.id
            };

            this.store.dispatch(
                new ImportAction({
                    showImporting: true,
                    showIcon: false,
                    text: 'Processing...',
                    error: false,
                    modalTitle: "3rd Party Report Attachment",
                    downloadIcon: true,
                    generateFile: true,
                    downloadAttachmentFileUrl: "",
                    adasThirdPartyJobId: receivedService.jobId,
                    apiData: apiData,
                })
            );
        });
    }

    calproReportAction(action, adasReportId, item: any = []) {
        let vin = (action == 'map') ? item.name : '';
        let make = (action == 'map') ? item.make : '';
        let model = (action == 'map') ? item.model : '';
        let year = (action == 'map') ? item.year : '';
        this.loadingRuleEngineActions = (action == 'map') ? true : false;
        this.removeLoading = (action == 'remove') ? true : false;
        if (action == 'map') {
            this.emptyFlag = false;
        }
        let apiInfo = {
            apiKey: Constant.ApiKey,
            userId: this.userId,
            domainId: this.domainId,
            roId: this.roId,
            adasReportId,
            action,
            vin,
            make,
            model,
            year
        };
        this.landingPageService.mapWorkOrderCalpro(apiInfo).subscribe((response) => {
            let status = response.status;
            if (status == 'Success') {
                let resultData = response.data;
                this.roData.adasImpactedStr = resultData.adasImpactedStr;
                this.roData.adasReportIdInt = resultData.adasReportIdInt;
                this.reportId = resultData.adasReportIdInt;
                this.roData.inspectionDataJsonArr = resultData.inspectionJsonArr;
                this.roData.businessInfoJsonArr = resultData.businessInfoJsonArr;
                this.inspectionInfo = (resultData.inspectionJsonArr && (resultData.inspectionJsonArr != null || resultData.inspectionJsonArr != undefined || resultData.inspectionJsonArr != '')) ? (resultData.inspectionJsonArr) : [];

                let businessInfo = (resultData.businessInfoJsonArr && (resultData.businessInfoJsonArr != null || resultData.businessInfoJsonArr != undefined || resultData.businessInfoJsonArr != '')) ? (resultData.businessInfoJsonArr) : '';
                if (businessInfo != '') {
                    console.log(businessInfo)
                    let space = ' ';
                    let dialCode = (businessInfo.dialCode && businessInfo.dialCode != undefined) ? `${businessInfo.dialCode}${space}` : businessInfo.dialCode;
                    businessInfo.dialCode = dialCode;

                    let email = businessInfo.email;
                    email = (email == null) ? '' : email;
                    if (email != '') {
                        let splitEmail = email.split(this.maskEmail);
                        email = (splitEmail.length > 1) ? '' : email;
                        businessInfo.email = email;
                        businessInfo.email = email;
                    }
                }
                this.roData.businessInfo = businessInfo;
                this.roData.businessInfoJsonArr = businessInfo;
                if (action == 'map') {
                    this.roData.threadCategoryInt = 1;
                    this.roData.vinNo = vin;
                    this.roData.vinNoStrField = vin;
                    this.roData.vinStr = vin;
                    this.roData.vehicleStr = item.vinInfo;
                    this.roData.make = make;
                    this.roData.model = model;
                    this.roData.year = year;
                    let chevron = '<i class="pi pi-chevron-right" style="font-size: 11px; vertical-align: text-top; margin-top: 0px;margin-left:12px;"></i>';
                    let vehicle = '-';
                    vehicle = (make != '') ? make : vehicle;
                    vehicle = (model != '') ? `${vehicle}${chevron}${model}` : vehicle;
                    vehicle = (year != '') ? `${vehicle}${chevron}${year}` : vehicle;
                    this.roData.makeVal = vehicle;
                    this.setupAdasReport(true);
                } else {
                    this.reportId = 0;
                    this.inspectionInfo = [];
                    this.businessInfo = [];
                    this.removeLoading = false;
                    this.roReportMapFlag = true;
                    this.emptyFlag = true;
                }
                setTimeout(() => {
                    this.adasReportCallback();
                }, 500);
            }
        });
    }

    adasReportCallback() {
        console.log('emit data');
        let calproAdasData: any = [];
        if (this.reportId > 0) {
            calproAdasData.push(this.inspectionData);
        }
        let action = (this.roId > 0) ? 'roData' : 'newData';
        let data = {
            action,
            roData: this.roData,
            reportId: this.reportId,
            calproAdasData
        }
        this.calproRefCallback.emit(this);
        this.adasReportEmit.emit(data);
    }

    downloadEstimate() {
        window.open(this.allDataApiService.estimateDownloadUrl(this.reportId), '_blank');
    }

    refreshReport(showAllData: boolean) {
        this.showAllData = showAllData;
        this.loadNewReportDetails();
    }

    getReportData(reportId, vinNo) {
        this.loading = true;
        const apiFormData = new FormData();
        apiFormData.append("apiKey", Constant.ApiKey);
        apiFormData.append("domainId", this.domainId);
        apiFormData.append("userId", this.userId);
        apiFormData.append("offset", '0');
        apiFormData.append("limit", '2');
        apiFormData.append("countryId", '');
        apiFormData.append("platform", '3');
        apiFormData.append("type", '2');
        apiFormData.append("vinNo", vinNo);
        this.landingPageService.adasrecentlist(apiFormData).subscribe((response) => {
            console.log(response);
            let resultData = response.items;
            this.emptyFlag = false;
            this.isNewReport = true;
            if (response && resultData && resultData.length > 0) {
                console.log(resultData)
                resultData.forEach(item => {
                    console.log(item.id, reportId)
                    if (item.id == reportId) {
                        console.log('in')
                        this.businessInfo = item.businessInfo[0];
                        let createdDate;
                        if (item.createdOn != undefined) {
                            let createdOn = item.createdOn;
                            createdOn = moment.utc(createdOn).toDate();
                            createdDate = moment(createdOn).local().format('MMM DD, YYYY h:mm A');
                        }
                        item.createdOnDate = createdDate;
                        this.inspectionData = item;
                        this.resultData = item.itemsData.result;
                        this.surveyData = item.surveyData;
                        let customerInfo = item.customerInfo;
                        this.customerInfo = (customerInfo.length > 0) ? customerInfo[0] : customerInfo;

                        try {
                            let email = this.customerInfo.email;
                            email = (email == null) ? '' : email;
                            if (email != '') {
                                let splitEmail = email.split(this.maskEmail);
                                email = (splitEmail.length > 1) ? '' : email;
                                this.customerInfo.email = email;
                                this.customerInfo.email = email;
                            }
                        } catch (e) {
                            console.error('Error processing email:', e);
                        }
                        let contactInfo = item.contactInfo;
                        this.contactInfo = (contactInfo.length > 0) ? contactInfo[0] : contactInfo;
                        console.log(this.customerInfo, this.contactInfo)


                        this.customerDataFlag = (customerInfo.length > 0) ? true : false;
                        this.contactDataFlag = (contactInfo.length > 0) ? true : false;
                        this.loading = false;
                        this.loadNewReportDetails(reportId, vinNo);
                        setTimeout(() => {
                            this.adasReportCallback();
                        }, 1500);
                    }
                });
            }
        });
    }

    updateIsEquipped(link: any, event: any) {
        link.equipped = !!event?.checked;
        this.updateAdasReport();
    }

    updateShow(link: any,  event: any) {
        link.show = !!event?.checked;
        this.updateAdasReport();
    }

    getLocationName(id) {
        return this.fixedLocations[id] || `Location ${id}`;
    }

    isArrayOfStrings(val: any): boolean {
        return Array.isArray(val) && val.every(item => typeof item === 'string');
    }

    isObject(val: any): boolean {
        return val && typeof val === 'object' && !Array.isArray(val);
    }

    private loadAIResponses() {
      if (this.allDataDetails) {
        this.allDataDetails.forEach((allDataInfo: any) => {
          this.getAIResponses(allDataInfo, false);
        });
      }
    }
}
